export enum EIconPosition {
    SITE = 'site',
    HEADER = 'header',
}
